import React from "react";
import { Skeleton } from "antd";
import HOME_PHONE from "../../../../../constants/lib/homePhone";

const ProductSkeleton: React.FC = () => (
  <>
    {Array.from({ length: HOME_PHONE.SKELETON_COUNT }).map((_, i) => (
      <Skeleton key={i} active avatar paragraph={{ rows: 2 }} />
    ))}
  </>
);

export default ProductSkeleton;
